import { RequirementConditionType } from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

const checkAnalysisHasScoreCondition = (
  analysisAutomationItem: AutomationFormItem
) =>
  analysisAutomationItem.requirementConditions.some(
    (condition) =>
      condition.type === RequirementConditionType.CandidateScoreCondition
  );

const checkIsConversationAutomationTask = (
  analysisAutomationItem: AutomationFormItem
) =>
  analysisAutomationItem.requirementConditions.some(
    (condition) =>
      condition.type === RequirementConditionType.ConversationScore ||
      condition.type === RequirementConditionType.ConversationStatusCondition ||
      condition.type ===
        RequirementConditionType.ConversationMandatoryQuestionsMet
  );

export const getAnalysisAutomationType = (
  analysisAutomationItem: AutomationFormItem
): 'analysisScore' | 'conversationScore' | 'analysisUnmet' => {
  if (checkIsConversationAutomationTask(analysisAutomationItem)) {
    return 'conversationScore';
  }

  if (checkAnalysisHasScoreCondition(analysisAutomationItem)) {
    return 'analysisScore';
  }

  return 'analysisUnmet';
};
